/* eslint-disable react/prop-types */

import React, {useState } from "react";
import { Form } from "react-bootstrap";

const SDCategorySelect = ({ initialValue, onUpdate, categories }) => {
    const [selectedValue, setSelectedValue] = useState(initialValue);

    const handleChange = async (e) => {
        const newValue = e.target.value;
        setSelectedValue(newValue);
        onUpdate(newValue);
    };

    return (
        <><Form.Select aria-label="Default select example" value={selectedValue} onChange={handleChange}>
            <option key={0} value={0}>
                    No Category
                </option>
            {categories.map((category) => (
                <option key={category.id} value={category.id}>
                    {category.name}
                </option>
            ))}

        </Form.Select></>
    );
}

export default SDCategorySelect;